import { PrintType } from '@/types';
import { getParams } from '@/utils/params';
import { Flex, Flock, SpecialFlex } from '@/model/printType/printTypes';
import { getIsRealisticFlexColor } from './getIsRealisticFlexColor';

const images = require.context('./patternImages');

export const getPatternImageHref = ({ id: printTypeId }: PrintType, printColorId: string) => {
  let type;
  let key;
  if (printTypeId === Flock) {
    type = 'flock';
    key = `${printColorId}.jpg`;
  }
  if (printTypeId === SpecialFlex) {
    type = 'specialFlex';
    key = `${getParams().platform}-${printColorId}.jpg`;
  }
  if (printTypeId === Flex && getIsRealisticFlexColor(printColorId)) {
    type = 'realisticFlexColors';
    key = `${printColorId}.jpg`;
  }

  try {
    return images(`./${type}/${key}`);
  } catch (error) {
    // should not happen, but better safe than sorry
  }

  return images('./danger.png');
};
